let globalMetafieldKey = null
let globalSpecKeys = new Set()
let globalDesktopColumns = null
let globalMobileColumns = null

// const ALLOWED_HTML_TAGS = ['b', 'strong', 'i', 'em', 'u', 's', 'strike', 'mark', 'sup', 'sub', 'big', 'small']
// const ALLOWED_TAGS_REGEX = new RegExp(`^</?(?:${ALLOWED_HTML_TAGS.join('|')})(?:\\s[^>]*)?>$`, 'i')
// const ALL_TAGS_REGEX = /<\/?[^>]+>/g
const EMPTY_CELL_VALUES = ['', '-', '—']
const DESKTOP_BREAKPOINT = 769

const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT
const getCurrentMaxColumns = () => isDesktop() ? globalDesktopColumns : globalMobileColumns

function parseHtml(text) {
  if (typeof text !== 'string') return text

  return text.replace(ALL_TAGS_REGEX, (match) => {
    if (ALLOWED_TAGS_REGEX.test(match)) {
      return match
    } else {
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePage);
} else {
  initializePage()
}

function initializePage () {
  if (window.productComparisonSectionId) {
    const container = document.getElementById(`product-comparison-${window.productComparisonSectionId}`)
    if (container) {
      initializeProductComparison(container)
    }
  }
}

function initializeProductComparison(container) {
  const dropdowns = Array.from(container.querySelectorAll('.product-comparison__product-dropdown'))
  const dataScript = document.getElementById(`product-comparison-data-${window.productComparisonSectionId}`)
  if (dataScript) {
    const products = JSON.parse(dataScript.textContent)
    const dropdownMap = populateDropdown(container, dropdowns[0], products)

    dropdowns.forEach(dropdown => {
      dropdown.innerHTML = dropdowns[0].innerHTML
      dropdown.value = dropdown.closest('.product-comparison__column-header')?.dataset.selectedProductId
      
      dropdown.addEventListener('change', (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex]
        const optionValue = selectedOption.value
        const duplicateDropdown = findDuplicateSelection(dropdowns, optionValue, e.target)
        if (duplicateDropdown) {
          const nearestProduct = findNearestAvailableProduct(dropdowns, dropdownMap)

          if (nearestProduct) {
            duplicateDropdown.value = nearestProduct.id
            const nearestOption = duplicateDropdown.querySelector(`option[value="${nearestProduct.id}"]`)
            if (nearestOption) {
              updateProductDetails(duplicateDropdown, dropdownMap[nearestProduct.id], nearestOption)
            }
          }
        }
        updateProductDetails(e.target, dropdownMap[optionValue], selectedOption)
      })
    })
    generateSpecificationRows(container, window.productComparisonSectionId, dropdownMap)
    setupResponsiveColumns(container)
  }
}

function setupResponsiveColumns(container) {
  globalDesktopColumns = parseInt(container.dataset.desktopColumns)
  globalMobileColumns = parseInt(container.dataset.mobileColumns)
  container.style.setProperty('--desktop-columns', globalDesktopColumns)
  container.style.setProperty('--mobile-columns', globalMobileColumns)

  const columns = container.querySelectorAll('.product-comparison__column')

  function updateVisibility() {
    const maxColumns = getCurrentMaxColumns()
    
    columns.forEach((column) => {
      const columnNumber = parseInt(column.dataset.column)
      if (columnNumber <= maxColumns) {
        column.style.display = 'block'
      } else {
        column.style.display = 'none'
      }
    })

    const specContainer = document.getElementById(`specifications-container-${window.productComparisonSectionId}`)
    Array.from(specContainer.children).forEach((specRow) => {
      Array.from(specRow.children).forEach((specAttr) => {
        Array.from(specAttr.children).forEach((cell, index) => {
          if (index >= maxColumns) {
            cell.style.display = 'none'
            cell.classList.remove('specification-item__empty')
          } else {
            if (!cell.textContent.trim() || ['-', '—'].includes(cell.textContent.trim())) {
              cell.classList.add('specification-item__empty')
            } else {
              cell.style.display = 'block'
            }
          }
        })
      })
      handleEmptySpecification(specRow)
    })
  }
  updateVisibility()
  window.addEventListener('resize', updateVisibility)
}

function generateSpecificationRows(container, sectionId, dropdownMap) {
  const specsContainer = document.getElementById(`specifications-container-${sectionId}`)
  if (!specsContainer) return

  if (!globalMetafieldKey || globalSpecKeys.size === 0) {
    Object.values(dropdownMap).forEach(product => {
      if (product.metafields && product.metafields.custom) {
        Object.entries(product.metafields.custom).forEach(([metaKey, metafieldData]) => {
          if (metaKey.includes('_specification')) {
            globalMetafieldKey = metaKey
            Object.keys(metafieldData.value).forEach(key => {
              globalSpecKeys.add(key)
            })
          }
        })
      }
    })
  }

  Array.from(globalSpecKeys).forEach((specKey, specIndex) => {
    const specRow = document.createElement('div')
    specRow.classList.add('product-comparison__specification-item', 'specification-item')
    specRow.setAttribute('data-spec-index', specIndex)
    specRow.setAttribute('data-spec-key', specKey)

    const specItemAttributes = ['icon', 'caption', 'title']
    for (let attribute of specItemAttributes) {
      const attributeElement = document.createElement('div')
      attributeElement.className = `specification-item__${attribute}`
      specRow.appendChild(attributeElement)
    }

    for (let i = 1; i <= 5; i++) {
      const selectedProductId = document.getElementById(`product-select-${i}`).value
      const product = dropdownMap[selectedProductId]
      if (product?.metafields?.custom?.[globalMetafieldKey]?.value) {
        let specData = product.metafields.custom[globalMetafieldKey].value?.[specKey] || {}
        renderSpecifications(specRow, i-1, specData)
      } else {
        renderSpecifications(specRow, i-1)
      }
    }
    handleEmptySpecification(specRow)
    specsContainer.appendChild(specRow)
  })
}

function renderSpecifications (container, productIndex, value = {}) {
  const iconRow = container.querySelector('.specification-item__icon')
  const captionRow = container.querySelector('.specification-item__caption')
  const titleRow = container.querySelector('.specification-item__title')
  const isEmptySpec = Object.values(value).every(v => !v)

  let specIcon
  if (value?.icon) {
    specIcon = document.createElement('img')
    specIcon.src = value.icon
    specIcon.alt = 'Specification item icon'
  } else {
    specIcon = document.createElement('div')
    specIcon.className = 'specification-item__empty'
    specIcon.style.marginBottom = '0'
    if (isEmptySpec) {
      specIcon.classList.add('specification-item__empty--all')
    }
  }
  renderSpecAttribute(iconRow, productIndex, specIcon)

  const specCaption = document.createElement('div')
  if (value?.caption) {
    specCaption.innerHTML = parseHtml(value.caption)
  } else {
    specCaption.className = 'specification-item__empty'
    specCaption.style.marginBottom = '0'
  }
  renderSpecAttribute(captionRow, productIndex, specCaption)

  const specTitle = document.createElement('div')
  if (value?.title) {
    specTitle.innerHTML = parseHtml(value.title)
  } else {
    specTitle.className = 'specification-item__empty'
    specTitle.style.marginBottom = '0'
  }
  renderSpecAttribute(titleRow, productIndex, specTitle)

  if (value?.description) {
    const descFragment = document.createDocumentFragment()
    Object.entries(value.description).forEach(([descIndex, descriptionText]) => {
      let descRow = container.querySelector(`.specification-item__description--${descIndex}`)
      if (!descRow) {
        descRow = document.createElement('div')
        descRow.classList.add('specification-item__description', `specification-item__description--${descIndex}`)
        descFragment.appendChild(descRow)
      }
      const specDesc = document.createElement('div')
      specDesc.innerHTML = parseHtml(descriptionText)
      renderSpecAttribute(descRow, productIndex, specDesc)
    })
    if (descFragment.hasChildNodes()) {
      container.appendChild(descFragment)
    }
  } else {
    const descRows = container.querySelectorAll('.specification-item__description')
    descRows.forEach(descRow => {
      const emptyElement = document.createElement('div')
      emptyElement.className = 'specification-item__empty'
      emptyElement.style.marginBottom = '0'
      renderSpecAttribute(descRow, productIndex, emptyElement)
    })
  }
}

function renderSpecAttribute (attrContainer, productIndex, attrElement) {
  const maxColumns = getCurrentMaxColumns()
  const existingChild = attrContainer.children[productIndex]
  if (productIndex >= maxColumns) {
    attrElement.style.display = 'none'
    attrElement.classList.remove('specification-item__empty')
  }

  if (existingChild) {
    attrContainer.replaceChild(attrElement, existingChild)
  } else {
    const childrenLength = attrContainer.children.length
    if (childrenLength < productIndex) {
      const fragment = document.createDocumentFragment()
      for (let childIndex = childrenLength; childIndex < productIndex; childIndex++) {
        const emptyElement = document.createElement('div')
        if (childIndex >= maxColumns) {
          emptyElement.style.display = 'none'
        } else {
          emptyElement.className = 'specification-item__empty'
        }
        fragment.appendChild(emptyElement)
      }
      attrContainer.appendChild(fragment)
    }
    attrContainer.appendChild(attrElement)
  }
}

function handleEmptySpecification (container) {
  const maxColumns = getCurrentMaxColumns()

  const descRows = container.querySelectorAll('.specification-item__description')
  descRows.forEach(descRow => {
    if (Array.from(descRow.children).every(cell => EMPTY_CELL_VALUES.includes(cell.textContent.trim()))) {
      descRow.remove()
    }
  })

  const specRowHeader = container.firstChild
  Array.from(specRowHeader.children).forEach((headerCell, index) => {
    if (headerCell.classList.contains('specification-item__empty--all')) {
      if (maxColumns && index >= maxColumns) {
        return
      }
      headerCell.style.display = 'block'
      headerCell.style.gridColumn = index + 1
      headerCell.style.gridRow = `1/${container.children.length + 1}`
      headerCell.textContent = '—'
      Array.from(container.children).forEach(specAttr => {
        specAttr.children[index]?.classList.remove('specification-item__empty')
      })
    }
  })
}

function updateProductDetails(dropdown, product, selectedOption) {
  const column = dropdown.closest('.product-comparison__column')
  if (column) {
    column.dataset.selectedProductId = product.id
  }
  updateImage(column, product)
  updateColorVariants(column, product)
  updateBuyButton(column, selectedOption.dataset.url)
  updateSpecifications(column, product)
}

function updateImage(column, product) {
  const columnNumber = column.dataset.column
  const imageRow = document.querySelector(`.product-comparison__row--image [data-column="${columnNumber}"]`)
  if (imageRow) {
    const imageContainer = imageRow.querySelector('.product-comparison__image')
    if (imageContainer) {
      imageContainer.innerHTML = `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">`
    }
  }
}

function updateColorVariants(column, product) {
  const columnNumber = column.dataset.column
  const colorRow = document.querySelector(`.product-comparison__row--color [data-column="${columnNumber}"]`)
  if (!colorRow) return

  const colorContainer = colorRow.querySelector('.product-comparison__color-variants')
  if (!colorContainer) return

  const colorOptionIndex = product.options.findIndex(opt => opt.toLowerCase() === 'color')
  if (colorOptionIndex === -1) {
    colorContainer.innerHTML = ''
    return
  }

  const colorValues = product.options_with_values[colorOptionIndex].values
  let html = '<div role="list" class="colornav-items">'
  html += '<div class="colornav-swatch-row">'

  colorValues.forEach(color => {
    const variant = product.variants.find(v => v.title.toLowerCase().includes(color.toLowerCase()))
    const colorCode = variant?.metafields?.custom?.colorcode?.value || '#ccc'
    html += `
      <div role="listitem" class="colornav-item">
        <figure role="img" aria-label="${color}" class="colornav-swatch" style="background-color: ${colorCode};"></figure>
      </div>
    `
  })

  html += '</div><div class="colornav-label-row">'
  colorValues.forEach((color, index) => {
    html += `<span class="colornav-item-label">${color}</span>`
    if (index < colorValues.length - 1) {
      html += ', '
    }
  })

  html += '</div></div>'
  colorContainer.innerHTML = html
}

function updateBuyButton(column, url) {
  const columnNumber = column.dataset.column
  const buyButtonRow = document.querySelector(`.product-comparison__row--buy-button [data-column="${columnNumber}"]`)
  if (buyButtonRow) {
    const buyButton = buyButtonRow.querySelector('.product-comparison__buy-button a')
    if (buyButton) {
      buyButton.href = url
    }
  }
}

function updateSpecifications(column, product) {
  const columnNumber = column.dataset.column
  const specRows = document.querySelectorAll('.product-comparison__specification-item')

  specRows.forEach(specRow => {
    const specKey = specRow.dataset.specKey
    if (product?.metafields?.custom?.[globalMetafieldKey]?.value) {
      let specData = product.metafields.custom[globalMetafieldKey].value?.[specKey] || {}
      renderSpecifications(specRow, columnNumber-1, specData)
    } else {
      renderSpecifications(specRow, columnNumber-1)
    }
    handleEmptySpecification(specRow)
  })
}

function populateDropdown (container, dropdown, products) {
  const productGrouping = container.dataset.productGrouping
  const productGroups = {}
  const dropdownMap = {}
  
  products.forEach(product => {
    let group = 'Model lainnya'
    switch (productGrouping) {
      case 'type':
        group = product.type ? product.type : group
        break
      case 'category':
        group = product.category ? product.category : group
        break
      case 'new':
        group = product.metafields.custom.is_new ? 'Model baru' : group
        break
      case 'current':
        group = product.metafields.custom.is_current ? 'Model saat ini' : group
        break
    }
    if (productGroups[group]) {
      productGroups[group].push(product)
    } else {
      productGroups[group] = [product]
    }
  })

  Object.keys(productGroups).forEach(group => {
    const groupedProducts = productGroups[group]
    if (groupedProducts.length > 0) {
      const optgroup = document.createElement('optgroup')
      optgroup.label = group

      groupedProducts.forEach(product => {
        const typeOptionIndex = product.options_with_values?.findIndex(opt => opt.name.toLowerCase() === 'type')
        
        if (typeOptionIndex === -1 || typeOptionIndex === undefined) {
          optgroup.appendChild(createOption(
            product.id,
            product.url,
            product.title
          ))
          dropdownMap[product.id] = product
        } else {
          const typeOptions = product.options_with_values[typeOptionIndex].values
          typeOptions.forEach(type => {
            const variant = product.variants.find(v => v.title.toLowerCase().includes(type.toLowerCase()))
            if (variant) {
              optgroup.appendChild(createOption(
                variant.id,
                variant.url,
                `${product.title} ${type}`,
                product.id
              ))
              dropdownMap[variant.id] = {
                ...variant,
                options: product.options,
                options_with_values: product.options_with_values,
                variants: product.variants
              }
            }
          })
        }
      })
      dropdown.appendChild(optgroup);
    }
  })
  return dropdownMap
}

function findDuplicateSelection(dropdowns, selectedValue, currentDropdown) {
  return dropdowns.find(dropdown =>
    dropdown !== currentDropdown && selectedValue === dropdown.value
  ) || false
}

function findNearestAvailableProduct(dropdowns, dropdownMap) {
  const selectedValues = new Set()
  dropdowns.forEach(dropdown => {
    if (dropdown.value) {
      selectedValues.add(dropdown.value)
    }
  })
  for (const [productId, product] of Object.entries(dropdownMap)) {
    if (!selectedValues.has(productId)) {
      return product
    }
  }
  return null
}

function createOption(value, url, text, productId = null) {
  const option = document.createElement('option')
  option.value = value
  option.textContent = text
  option.dataset.url = url
  option.dataset.productId = productId || value
  return option
}
